export type FeatureFlag = {
	id: number;
	description?: string;
	name: string;
};

// map so we can ensure only get correct Features
export const enum FeatureFlagType {
	ENABLE_RFX_FUNCTIONALITY = 1,
	TEST_ACCOUNT = 2,
	TERMS_AND_CONDITIONS = 3,
	ENABLE_NEW_SUBMISSION_PDF = 4,
	ENABLE_DASHBOARD = 5,
	ENABLE_PRE_APPROVAL_FLOW = 6,
	RESTRICT_RFX_SUBMISSION_VIEW = 10,
	ENABLE_ONBOARDING = 11,
	ENABLE_CLARIFICATIONS = 12,
	ENABLE_AI = 13,
	ENABLE_AI_EVALUATION = 14,
	ENABLE_RFX_EVALUATION = 15,
	ENABLE_PERFORMANCE_MANAGEMENT = 16,
	CUSTOMISE_SHORTLIST_REPORT = 18,
	ENABLE_REPORT_BRANDING_FOR_SUPPLIER = 19,
	// Backend: feature_flags id=20 (enableInsuranceVerification)
	ENABLE_INSURANCE_VERIFICATION = 20,
	// Backend: feature_flags id=21 (enableManualInsuranceVerification)
	ENABLE_MANUAL_INSURANCE_VERIFICATION = 21,
	// Backend: feature_flags id=22 (enable2fa)
	ENABLE_2FA = 22,
}
